import { render } from "./EposMenuBar.vue?vue&type=template&id=012dcf22"
import script from "./EposMenuBar.vue?vue&type=script&lang=js"
export * from "./EposMenuBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__